import { gql } from "@apollo/client";

export const usersListQuery = gql`
    query UsersListAdmin(
        $page: Int
        $sort: SortInput
        $query: String
        $country: String
        $cameraStatus: CameraStatus
        $size: Int
        $withDeleted: Boolean
    ) {
        usersListAdmin(
            page: $page
            sort: $sort
            query: $query
            country: $country
            cameraStatus: $cameraStatus
            size: $size
            withDeleted: $withDeleted
        ) {
            nodes {
                id
                firstname
                lastname
                email
                address
                zipCode
                city
                phone
                country
                agb
                newsletter
                aboReminder
                ecg
                createdAt
                updatedAt
                cameras {
                    id
                    status
                }
                lastValidated
            }
            totalCount
            nextPage
            previousPage
            totalPages
        }
    }
`;

export const restoreUser = gql`
    mutation RestoreUser($id: ID!) {
        restoreUserAdmin(id: $id)
    }
`;
